/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import GetPayHistoryActionBox from '../ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import './tables_styles.css';
import EmployeeNamePic from '../EmployeeNamePic/EmployeeNamePic';
import AwardsARModalController from '../../Modals/ActionRequiredModals/AwardsARModal/AwardsARModalController';
import { useAppSelector } from '../../../infra/hooks';
import _ from 'lodash';
import { actionRequiredService } from '../../../api/services/actionRequiredService';
import { useTranslate } from '../../../hooks';
import { arabicDataGrid, baseDateFormatting } from '../../helper';
import { DateField } from '../../../components';

interface Propval {
  trans: any;
}
const Award = ({ trans }: Propval) => {
  const [openModal, setOpenModal] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [awardHistory, setAwardHistory] = useState([]);

  const storedARData = useAppSelector(
    (state) => state.actionRequiredSlice.actionRequiredData,
  );

  const getAwardsHistory = (eid: any, cid: any) => {
    actionRequiredService.getAwardsHistory(eid, cid).then((result) => {
      setAwardHistory(result?.data);
    });
  };
  const handleAwardView = (award: any) => {
    getAwardsHistory(award.emp_id, award.company_id);

    setFullData(award);
  };
  const tableColumns: any = [
    {
      field: 'empId',
      headerName: trans('Emp Id'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'empName',
      headerName: trans('Emp Name'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params:any) => {
        return <EmployeeNamePic name={params?.row?.name} picture="" />;
      },
    },
    {
      field: 'designation',
      headerName: trans('Designation'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },

    {
      field: 'awardType',
      headerName: trans('Award Type'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'giftType',
      headerName: trans('Gift Type'),

      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
    },
    {
      field: 'date',
      headerName: trans('Date'),
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'header',
      height: 70,
      renderCell: (params: any) => (
        <DateField value={params?.row?.date} format={baseDateFormatting} />
      ),
    },

    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleAwardView(params?.row?.fullData);
              setOpenModal(true);
            }}
          />
        );
      },

      height: 70,
    },
  ];

  const row_data = _.map(storedARData, (pro: any, index: any) => {
    return {
      id: index,
      empId: `#${pro.request_id}`,
      name: pro.first_name + ' ' + pro.last_name,
      profilePic: pro.profile_pic,
      awardType: pro.award,
      designation: pro.designation_name,
      giftType: pro.gift ? pro.gift : '--',
      date: pro.award_date,
      fullData: pro,
    };
  });

  const { isRTL } = useTranslate();

  return (
    <>
      <Box
        className="ar_table"
        sx={{
          '& .header': {
            backgroundColor: '#F5F5F5',
          },

          width: '100%',
          marginTop: '2em',
        }}
      >
        <DataGrid
          sx={{
            color: '#081735',
            font: 'normal normal normal 14px/24px Lato;',
          }}
          autoHeight
          disableExtendRowFullWidth
          disableSelectionOnClick
          disableColumnMenu
          rows={row_data}
          columns={tableColumns}
          localeText={isRTL ? arabicDataGrid : undefined}
          componentsProps={{
            pagination: {
              labelRowsPerPage: trans('Rows per page'),
            },
          }}
        />
      </Box>
      {openModal && (
        <AwardsARModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          awardHistory={awardHistory}
          awardData={fullData}
        />
      )}
    </>
  );
};

export default Award;
